export const timezones: string[] = Intl.supportedValuesOf('timeZone').slice().sort();
